import React from "react";
import classes from "./FormCard.module.scss";
import arrowRightIcon from "../../media/icons/arrowRight.svg";
import { useTranslation } from "react-i18next";

const CardText: React.FC<{
  title: string;
  subtitle: string;
  message: string;
  buttonText: string;
}> = ({ title, subtitle, message, buttonText }) => {

  const { t } = useTranslation();

  return (
    <div className={classes["card-text-container"]}>
      <div className={classes["heading-container"]}>
        <div className={classes["card-text-container__heading"]}>
          <span className={classes["heading-with-icon"]}>
            {title || t('form.title')}
            <img
              className={classes["arrow-icon"]}
              src={arrowRightIcon}
              alt="Arrow to right"
            />
          </span>
          <img
            className={classes["arrow-icon-down"]}
            src={arrowRightIcon}
            alt="Arrow to down"
          />
        </div>
        {!!subtitle && <h3>{subtitle}</h3>}
      </div>

      <div className={classes["card-text"]}>
        <h4>
          {message || t('form.text')}
        </h4>
        <p className={classes["card-text-container__email"]}>info@go-te.co</p>
      </div>
    </div>
  );
};

export default CardText;
